function Delete() {
  return (
    <svg width={34} height={40} viewBox="0 0 34 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.333 3.333H25L22.618 0H10.715L8.333 3.333H0v3.334h33.333V3.333zm-30 32.382a4.38 4.38 0 004.445 4.284h17.777A4.38 4.38 0 0030 35.715V10H3.333v25.715z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Delete;
